/**
 * Created by Administrator on 2017/3/18.
 */
!(function (win, designWidth) {
  //计算最终html font-size
  function modifyRootRem() {
    try {
      let fontSize = parseFloat(domEle.style.fontSize);
      let finalFontSize = parseFloat(
        win.getComputedStyle(domEle).getPropertyValue("font-size")
      );
      if (finalFontSize === fontSize) return;
      domEle.style.fontSize =
        Math.floor(fontSize / (finalFontSize / fontSize)) + "px";
    } catch (e) {
      //win.console.error(e.message,e);
    }
  }

  function resize() {
    let domWidth = domEle.getBoundingClientRect().width;

    if (domWidth / v > 540) {
      domWidth = 540 * v;
    }

    win.rem = (domWidth * 100) / designWidth; //domWidth / 10;
    if (!n) win.rem *= v;
    //console.log(domWidth, win.rem,n,v)
    domEle.style.fontSize = Math.floor(win.rem) + "px";
    let rem = win.rem;
    // setTimeout(() => {
    //   modifyRootRem();
    // });
  }

  let v,
    n,
    initial_scale,
    timeCode,
    dom = win.document,
    domEle = dom.documentElement,
    o,
    viewport = dom.querySelector('meta[name="viewport"]'),
    flexible = dom.querySelector('meta[name="flexible"]');
  if (viewport) {
    o = viewport
      .getAttribute("content")
      .match(/initial-scale=(["']?)([\d.]+)\1?/);
    if (o) {
      initial_scale = parseFloat(o[2]);
      v = parseInt(1 / initial_scale);
    }
  } else if (flexible) {
    o = flexible
      .getAttribute("content")
      .match(/initial-dpr=(["']?)([\d.]+)\1?/);
    if (o) {
      v = parseFloat(o[2]);
      initial_scale = parseFloat((1 / v).toFixed(2));
    }
  }
  if (!v && !initial_scale) {
    n =
      (win.navigator.appVersion.match(/android/gi),
        win.navigator.appVersion.match(/iphone/gi));
    v = win.devicePixelRatio;
    (v = n ? (v >= 3 ? 3 : v >= 2 ? 2 : 1) : 1), (initial_scale = 1 / v);
  }
  //没有viewport标签的情况下
  if ((domEle.setAttribute("data-dpr", v), !viewport)) {
    if (
      ((viewport = dom.createElement("meta")),
        viewport.setAttribute("name", "viewport"),
        viewport.setAttribute(
          "content",
          "initial-scale=" +
          initial_scale +
          ", maximum-scale=" +
          initial_scale +
          ", minimum-scale=" +
          initial_scale +
          ", user-scalable=0, viewport-fit=cover"
        ),
        domEle.firstElementChild)
    ) {
      domEle.firstElementChild.appendChild(viewport);
    } else {
      let m = dom.createElement("div");
      m.appendChild(viewport), dom.write(m.innerHTML);
    }
  }
  let winWidth = win.innerWidth,
    winHeight = win.innerHeight;
  win.dpr = v;
  win.addEventListener(
    "resize",
    function () {
      clearTimeout(timeCode), (timeCode = setTimeout(resize, 300));
      let _winWidth = win.innerWidth,
        _winHeight = win.innerHeight;
      if (_winWidth === winWidth) {
        //document.body.className = _winHeight < winHeight ? 'keyboard' : '';
        let bodyClassList = document.body.classList;
        if (_winHeight < winHeight) {
          bodyClassList.add("keyboard");
        } else {
          bodyClassList.remove("keyboard");
        }
      }
    },
    false
  );
  win.addEventListener(
    "pageshow",
    function (b) {
      b.persisted &&
        (clearTimeout(timeCode), (timeCode = setTimeout(resize, 300)));
    },
    false
  );
  resize();
})(window, 750);
